import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

import { useConversationPanelToggle } from "./hooks/useConversationPanelToggle";
import { DOM_IDS } from "./Layout/defaults";

export const ConversationPanelToggleButton = () => {
  const { isOpen, toggle } = useConversationPanelToggle();
  const ariaLabel = isOpen
    ? t("circle_ai_shell.close_ai_canvas")
    : t("circle_ai_shell.open_ai_canvas");

  return (
    <IconButton
      data-testid="circle-ai-shell-ai-canvas-toggle"
      data-circle-ai-toggle="dock"
      onClick={toggle}
      icon={isOpen ? "sparkles-filled" : "sparkles"}
      variant="ghost"
      data-popup-open={isOpen || undefined}
      title={ariaLabel}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      aria-pressed={isOpen}
      aria-controls={DOM_IDS.conversationPanelBody}
    />
  );
};

ConversationPanelToggleButton.displayName =
  "CircleAIAppShell.ConversationPanelToggleButton";
